"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApTrackModalForm = void 0;
var React = require("react");
var ApButtonGroup_1 = require("../../ApButtonGroup");
var ApButtons_1 = require("../../ApButtons");
var ApInput_1 = require("../../ApInput");
var ApPeriodPicker_1 = require("../../ApPeriodPicker");
var ApSelect_1 = require("../../ApSelect");
var styles_1 = require("./styles");
var PeriodType;
(function (PeriodType) {
    PeriodType["ANNUAL"] = "Annual";
    PeriodType["QUARTER"] = "Quarter";
    PeriodType["MONTH"] = "Month";
})(PeriodType || (PeriodType = {}));
var OpportunityType;
(function (OpportunityType) {
    OpportunityType["POINT_IN_TIME"] = "PointInTime";
    OpportunityType["AGGREGATED"] = "Aggregated";
})(OpportunityType || (OpportunityType = {}));
var Unit;
(function (Unit) {
    Unit["Thousands"] = "k";
    Unit["Millions"] = "m";
    Unit["Billions"] = "b";
    Unit["Percentage"] = "%";
})(Unit || (Unit = {}));
var Currency;
(function (Currency) {
    Currency["USD"] = "usd";
    Currency["EUR"] = "eur";
    Currency["GBP"] = "gbp";
})(Currency || (Currency = {}));
var UNIT_MULTIPLIER = (_a = {},
    _a[Unit.Percentage] = 0.01,
    _a[Unit.Thousands] = 1000,
    _a[Unit.Millions] = 1000000,
    _a[Unit.Billions] = 1000000000,
    _a);
var UNIT_LABELS = (_b = {},
    _b[Unit.Percentage] = '%',
    _b[Unit.Thousands] = 'K',
    _b[Unit.Millions] = 'M',
    _b[Unit.Billions] = 'B',
    _b);
var CURRENCY_SYMBOL = (_c = {},
    _c[Currency.USD] = '$',
    _c[Currency.GBP] = '£',
    _c[Currency.EUR] = '€',
    _c);
var getCurrencySymbol = function (currency) {
    if (!currency) {
        return '';
    }
    return CURRENCY_SYMBOL[currency] || currency.toUpperCase();
};
var PERIOD_TYPES_OPTIONS = [
    { label: 'an annual', value: PeriodType.ANNUAL },
    { label: 'a quarter', value: PeriodType.QUARTER },
    { label: 'a month', value: PeriodType.MONTH },
];
exports.ApTrackModalForm = function (_a) {
    var className = _a.className, data = _a.data, isLoading = _a.isLoading, isOpen = _a.isOpen, showPeriod = _a.showPeriod, onChange = _a.onChange, onClose = _a.onClose, onSave = _a.onSave;
    var isPointInTime = data.type === OpportunityType.POINT_IN_TIME;
    var changeInput = function (name) { return function (value) {
        var _a;
        onChange(__assign(__assign({}, data), (_a = {}, _a[name] = value, _a)));
    }; };
    var changePeriodType = function (value) {
        onChange(__assign(__assign({}, data), { deadlineType: value, deadlineValue: undefined, deadlineYear: undefined }));
    };
    var changeTargetValue = function (value) {
        var targetValue = value !== '' ? Number(value) : undefined;
        if (data.targetUnit && targetValue != null) {
            var multiplier = UNIT_MULTIPLIER[data.targetUnit];
            if (multiplier) {
                targetValue = targetValue * multiplier;
            }
        }
        onChange(__assign(__assign({}, data), { targetValue: targetValue }));
    };
    var changePeriod = function (period) {
        onChange(__assign(__assign({}, data), { deadlineValue: period.period, deadlineYear: period.year }));
    };
    var isInvalid = function () {
        return (!data.name ||
            !data.title ||
            !data.targetValue ||
            !data.owner ||
            (!data.deadlineType && !isPointInTime) ||
            !data.deadlineYear ||
            !data.deadlineValue);
    };
    var getFormattedTarget = function () {
        var multiplier = data.targetUnit ? UNIT_MULTIPLIER[data.targetUnit] : null;
        return data.targetValue != null
            ? data.targetUnit && multiplier
                ? data.targetValue / multiplier
                : data.targetValue
            : '';
    };
    var getTargetSymbol = function () {
        return "" + (data.targetCurrency ? getCurrencySymbol(data.targetCurrency) : '') + (data.targetUnit ? UNIT_LABELS[data.targetUnit] || data.targetUnit : '');
    };
    var targetSymbol = getTargetSymbol();
    return (React.createElement(styles_1.StyledModal, { className: className, isOpen: isOpen, header: "Track an item", isDismissible: true, hasClosed: onClose, footer: function (_a) {
            var handleClose = _a.handleClose;
            return (React.createElement(ApButtonGroup_1.ApButtonGroup, { justifyContent: "flex-end" },
                React.createElement(styles_1.StyledButtonSecondary, { onClick: handleClose }, "Cancel"),
                React.createElement(ApButtons_1.ApButtonMain, { onClick: onSave, disabled: isLoading || isInvalid() }, "Save and track")));
        } },
        React.createElement(styles_1.SubheaderSection, null,
            React.createElement(styles_1.SubheaderText, null, data.name),
            React.createElement(styles_1.SubheaderHelper, null, data.subTitle),
            data.tags && (React.createElement(styles_1.SubheaderTags, null, data.tags.map(function (tag, i) { return (React.createElement(styles_1.StyledChip, { key: i, small: true }, tag)); })))),
        React.createElement(styles_1.Content, null,
            React.createElement(styles_1.LabelText, null, "Target"),
            React.createElement(styles_1.InputRow, { symbolLength: targetSymbol.length },
                !isPointInTime ? (React.createElement(React.Fragment, null,
                    React.createElement(styles_1.Text, null, "Set"),
                    React.createElement(ApSelect_1.ApSelect, { name: "select-period", value: data.deadlineType != null ? data.deadlineType : '', options: PERIOD_TYPES_OPTIONS, onChange: changePeriodType, placeholder: "select" }),
                    React.createElement(styles_1.Text, null, "target of"))) : (React.createElement(styles_1.Text, null, "Set target of")),
                React.createElement(styles_1.TargetInput, __assign({ onChange: changeTargetValue, value: getFormattedTarget(), symbol: targetSymbol }, { type: 'number' })),
                React.createElement(styles_1.Text, null, "for"),
                React.createElement(styles_1.PeriodInput, null,
                    React.createElement(ApPeriodPicker_1.ApPeriodPicker, { onChange: changePeriod, showPeriod: showPeriod ||
                            isPointInTime ||
                            data.deadlineType === PeriodType.MONTH, isQuarter: data.deadlineType === PeriodType.QUARTER, data: { year: data.deadlineYear, period: data.deadlineValue }, disabled: !isPointInTime && !data.deadlineType }))),
            React.createElement(styles_1.Divider, null),
            React.createElement(styles_1.InputWrapper, null,
                React.createElement(ApInput_1.ApInput, { onChange: changeInput('title'), label: "Title *", value: data.title || '', maxLength: 75 })),
            React.createElement(styles_1.InputWrapper, null,
                React.createElement(ApInput_1.ApInput, { onChange: changeInput('description'), label: "Description (optional)", maxLength: 150, value: data.description || '' })),
            React.createElement(styles_1.InputWrapper, null,
                React.createElement(ApInput_1.ApInput, { onChange: changeInput('owner'), label: "Owner *", value: data.owner || '' })))));
};
exports.ApTrackModalForm.defaultProps = {
    showPeriod: false,
    isLoading: false,
};
//# sourceMappingURL=ApTrackModalForm.js.map